console.log('js is plugged correctly');

class MobileMenu {
  constructor() {
    this.menu = document.querySelector('.menu-panel-wrapper');
    this.openButton = document.querySelector('#mobile-menu-open-btn');
    this.closeButton = null;
    this.searchButton = null;
    this.overlay = null;

    this.init();
  }

  init() {
    if (!this.menu) return;

    // Create overlay
    this.createOverlay();

    // Bind events
    if (this.openButton) {
      this.openButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // Find close button within the menu wrapper
    this.closeButton = this.menu.querySelector('#menu-panel-close-btn');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.close();
      });
    }

    // Find search button within the menu wrapper
    this.searchButton = this.menu.querySelector('#mobile-menu-search-btn');
    if (this.searchButton) {
      this.searchButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearchPanel();
      });
    }

    // Close on overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.menu.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  openSearchPanel() {
    // Close the menu panel first
    this.close();

    // Wait for menu to close, then open search panel
    setTimeout(() => {
      const searchOpenButton = document.querySelector('#mobile-search-open-btn');
      if (searchOpenButton) {
        searchOpenButton.click();
      }
    }, 300); // Wait for the menu close animation (0.3s)
  }

  createOverlay() {
    this.overlay = document.createElement('div');
    this.overlay.className = 'menu-panel-overlay';
    document.body.appendChild(this.overlay);
  }

  open() {
    this.menu.classList.add('is-open');
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.menu.classList.remove('is-open');
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
  });
} else {
  new MobileMenu();
}
